import React from 'react';

const ProgressBar = ({ currentStep, totalSteps = 4 }) => {
  const percentage = (currentStep / totalSteps) * 100;
  
  return (
    <div className="mb-8">
      {/* Step indicator */}
      <div className="flex justify-between items-center mb-3">
        <span className="text-sm font-medium text-text-gray dark:text-dark-text-secondary">
          Step {currentStep} of {totalSteps}
        </span>
        <span className="text-sm font-medium text-primary">
          {Math.round(percentage)}% Complete
        </span>
      </div>
      
      {/* Progress bar */}
      <div className="w-full h-2 bg-gray-200 dark:bg-dark-border rounded-full overflow-hidden">
        <div 
          className="h-full bg-gradient-to-r from-primary to-primary-dark transition-all duration-500 ease-out"
          style={{ width: `${percentage}%` }}
        />
      </div>
      
      {/* Step dots */}
      <div className="flex justify-between mt-4">
        {[1, 2, 3, 4].map((step) => (
          <div 
            key={step}
            className={`
              flex flex-col items-center gap-2 flex-1
              ${step === currentStep ? 'opacity-100' : 'opacity-40'}
            `}
          >
            <div className={`
              w-10 h-10 rounded-full flex items-center justify-center text-sm font-bold
              transition-all duration-300
              ${step < currentStep 
                ? 'bg-green-500 text-white' 
                : step === currentStep 
                  ? 'bg-primary text-white scale-110' 
                  : 'bg-gray-300 dark:bg-dark-border text-text-gray'
              }
            `}>
              {step < currentStep ? '✓' : step}
            </div>
            <span className="text-xs text-center text-text-gray dark:text-dark-text-secondary">
              {step === 1 && 'Define Purpose'}
              {step === 2 && 'AI Generation'}
              {step === 3 && 'Publish'}
              {step === 4 && 'Download'}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProgressBar;
